import React from 'react';
import { motion } from 'framer-motion';

export default function Disclaimer() {
  return (
    <div className="min-h-screen bg-white py-16 px-4">
      <motion.div 
        className="max-w-4xl mx-auto"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <h1 className="text-4xl font-serif font-bold text-blue-900 mb-8">Disclaimer</h1>
        
        <div className="prose prose-lg max-w-none">
          <p className="text-gray-600 mb-6">Last updated: {new Date().toLocaleDateString()}</p>

          <section className="mb-8">
            <h2 className="text-2xl font-serif font-semibold text-blue-900 mb-4">1. Investment Information</h2>
            <p className="text-gray-700 mb-4">
              The information provided on bigDEAL Capital's website is for educational and informational purposes only. It is not intended to be, and should not be construed as, investment advice. All investment decisions should be made after careful consideration of your personal financial situation and consultation with qualified financial professionals.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-serif font-semibold text-blue-900 mb-4">2. No Guarantees</h2>
            <p className="text-gray-700 mb-4">
              Past performance is not indicative of future results. We make no guarantees regarding the accuracy, completeness, or reliability of any information on our website. Investment markets are inherently risky, and you should be prepared to lose some or all of your invested capital.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-serif font-semibold text-blue-900 mb-4">3. Third-Party Content</h2>
            <p className="text-gray-700 mb-4">
              Our website may contain links to third-party websites and content. We are not responsible for the accuracy, completeness, or reliability of any third-party content. The inclusion of such content does not constitute an endorsement by bigDEAL Capital.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-serif font-semibold text-blue-900 mb-4">4. Professional Advice</h2>
            <p className="text-gray-700 mb-4">
              The content on our website should not be considered a substitute for professional financial advice. Always consult with qualified financial advisors, accountants, or legal professionals before making any investment decisions.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-serif font-semibold text-blue-900 mb-4">5. Market Risks</h2>
            <p className="text-gray-700 mb-4">
              All investments involve risk, including the potential loss of principal. Market conditions can change rapidly, and past performance is not indicative of future results. You should carefully consider your investment objectives, risks, and costs before investing.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-serif font-semibold text-blue-900 mb-4">6. Contact Information</h2>
            <p className="text-gray-700 mb-4">
              If you have any questions about this Disclaimer, please contact us at{' '}
              <a href="mailto:mitalibharalibusiness@gmail.com" className="text-blue-600 hover:text-blue-800">
                mitalibharalibusiness@gmail.com
              </a>
            </p>
          </section>
        </div>
      </motion.div>
    </div>
  );
} 